<template>
  <div style="height:100%">
    <div id="map" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
export default {
  props: {
    searchAredss: "",
    centerMarker: { lat: 39, lng: 116 }, //中心点marker
    // inspMarkerArr: {
    //   type: Array,
    //   default: [],
    // }, //验货员覆盖
    // orderMarkerArr: {
    //   type: Array,
    //   default: [],
    // }, //订单覆盖
    // userMarkerArr: {
    //   type: Array,
    //   default: [],
    // }, //客户覆盖
  },
  data() {
    return {
      center: { lat: 39, lng: 116 }, //地图中心点
      markers: [],
      place: null,
      params: "",
      inspData: "",
    };
  },
  // description: "Autocomplete Example (#164)",
  watch: {
    searchAredss(val) {
      this.params = val;
      this.getAdress(1);
    },
    // inspMarkerArr(val) {
    //   if (val) {
    //     this.setLayout(val, 0);
    //   }
    // },
    // orderMarkerArr(val) {
    //   if (val) {
    //     this.setLayout(val, 1);
    //   }
    // },
    // userMarkerArr(val) {
    //   if (val) {
    //     this.setLayout(val, 2);
    //   }
    // },
  },

  mounted() {
    this.center = this.centerMarker ? this.centerMarker : { lat: 39, lng: 116 };
    this.mapBuild();
    // 添加覆盖物
    // if (this.inspMarkerArr) {
    //   this.setLayout(this.inspMarkerArr, 0);
    // }
    // if (this.orderMarkerArr) {
    //   this.setLayout(this.orderMarkerArr, 1);
    // }
    // if (this.userMarkerArr) {
    //   this.setLayout(this.userMarkerArr, 2);
    // }
  },

  methods: {
    mapBuild() {
      //创建地图实例，zoom是缩放比例
      this.map = new google.maps.Map(document.getElementById("map"), {
        zoom: 5,
        center: this.center,
      });
      // this.setCenter()
      let that = this;
      this.map.addListener("click", (e) => {
        // console.log(e.latLng.lat());
        // console.log(e.latLng.lng());
        that.center = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        that.params = e.latLng;
        // console.log(that.center);
        // console.log(that.map);
        that.getAdress(2);
      });
    },
    // 地址逆解析
    getAdress(type) {
      //实例化Geocoder服务
      let resultArr = [];
      let that = this;
      var geocoder = new google.maps.Geocoder();
      if (type == 1) {
        //1.地理解析过程
        //请求数据GeocoderRequest为address，值为'贵阳'
        geocoder.geocode({ address: this.params }, async function geoResults(
          results,
          status
        ) {
          //这里是回掉函数(即结果处理函数)
          //状态为Ok说明有结果
          if (status == google.maps.GeocoderStatus.OK) {
            //一般情况下会有多个结果
            //第一个结果为最佳匹配的结果（匹配地名最全的结果），这里只去第一个，其他的可以根据需要自己循环出来
            //格式化过后的地址
            // alert('地理解析结果：'+results[0].formatted_address);
            // //geometry是一个包含bounds（界限），location（纬度/经度坐标）,location_type和viewport（视图范围）
            // //获取解析后的经纬度
            // alert('地理解析结果：'+results[0].geometry.location);
            // console.log(results[0]);
            await that.$emit("getAdressInfo", {
              data: resultArr,
              lngAndlat: that.params,
            });
          } else {
            alert("：error " + status);
          }
        });
      } else {
        //2.地理反解析过程
        //请求数据GeocoderRequest为location，值类型为LatLng因此我们要实例化经纬度
        geocoder.geocode({ location: this.params }, async function geoResults(
          results,
          status
        ) {
          //这里处理结果和上面一模一样
          if (status == google.maps.GeocoderStatus.OK) {
            resultArr = results;
            await that.$emit("getAdressInfo", {
              data: resultArr,
              lngAndlat: that.params,
            });
            // alert('地理反解析结果：'+results[0].formatted_address);
            // alert('地理反解析结果：'+results[0].geometry.location);
          } else {
            alert("：error " + status);
          }
        });
      }
    },
    // 设置中心点marker
    setCenter() {
      var marker = new google.maps.Marker({
        position: this.center,
        title: "Click to zoom",
      });

      marker.setMap(this.map);
    },
    clearOverlays(mk) {
      for (var i = 0; i < mk.length; i++) {
        mk[i].setMap(null);
      }
      mk.length = 0;
    },
    // status   type:
    toggleChange(type, status) {
      // console.log(type, status);
      if (type === 0 && status === false) {
        this.clearOverlays(this.marker1);
      } else if (type === 1 && status === false) {
        this.clearOverlays(this.marker2);
      } else if (type === 2 && status === false) {
        this.clearOverlays(this.marker3);
      } else if (type === 0 && status === true) {
        this.addMarkes(this.inspData, type);
      } else if (type === 1 && status === true) {
        this.addMarkes(this.orderData, type);
      } else if (type === 2 && status === true) {
        this.addMarkes(this.userData, type);
      }
    },

    addMarkes(data, type) {
      // console.log(data, type);

      if (type === 0) {
        let mk = [];
        // mk = this.marker1;
        // console.log(data.length);
        data.map((item) => {
          mk.push(
            new google.maps.Marker({
              position: new google.maps.LatLng(item.lat, item.lon),
              // animation: google.maps.Animation.DROP,
              map: this.map,
            })
          );
        });
        this.marker1 = mk;
      } else if (type === 1) {
        let mk = [];
        // mk = this.marker2;
        // console.log(data.length);
        data.map((item) => {
          mk.push(
            new google.maps.Marker({
              position: new google.maps.LatLng(item.lat, item.lon),
              // animation: google.maps.Animation.DROP,
              icon: "http://www.inspector.ltd/red-circle.png",
              map: this.map,
            })
          );
        });
        this.marker2 = mk;
      } else {
        let mk = [];
        // mk = this.marker3;
        // console.log(data.length);
        data.map((item) => {
          mk.push(
            new google.maps.Marker({
              position: new google.maps.LatLng(item.lat, item.lon),
              // animation: google.maps.Animation.DROP,
              icon: "http://www.inspector.ltd/green-circle.png",
              map: this.map,
            })
          );
        });
        this.marker3 = mk;
      }
    },
    // setMap(null)
    // 验货员覆盖物
    setLayout(data, type) {
      let that = this;
      // let marker = null;
      if (type == 0) {
        this.inspData = data;
        //验货员
        let mks = [];
        if (this.marker1) {
          this.clearOverlays(this.marker1);
        }

        data.forEach((item) => {
          mks.push(
            new google.maps.Marker({
              position: new google.maps.LatLng(item.lat, item.lon),
              map: that.map,
            })
          );
        });
        this.marker1 = mks;
      } else if (type == 1) {
        this.orderData = data;
        //订单
        let mks = [];
        if (this.marker2) {
          this.clearOverlays(this.marker2);
        }

        data.forEach((item) => {
          mks.push(
            new google.maps.Marker({
              position: new google.maps.LatLng(item.lat, item.lon),
              icon: "http://www.inspector.ltd/red-circle.png",
              map: that.map,
            })
          );
        });
        this.marker2 = mks;
      } else if (type == 2) {
        this.userData = data;
        //用户
        let point = [];
        let mks = [];
        if (this.marker3) {
          this.clearOverlays(this.marker3);
        }

        data.forEach((e) => {
          if (e.lon && e.lat) {
            point = [e.lon, e.lat];
          } else if (e.city.length) {
            // 计算两经纬度中心店
            if (typeof e.city.rectangle == "object") {
              point = [];
            } else if (e.city.rectangle.split(";").length > 1) {
              let pointArr = [];
              e.city.rectangle.split(";").forEach((item) => {
                pointArr.push(item.split(","));
              });
              let lng = 0; //精度和
              let lnt = 0; //纬度和
              pointArr.forEach((item) => {
                lng += parseFloat(item[0]);
                lnt += parseFloat(item[1]);
              });
              point = [lng / pointArr.length, lnt / pointArr.length];
            } else {
              point = e.city.rectangle.split(",");
            }
          }
          mks.push(
            new google.maps.Marker({
              position: new google.maps.LatLng(point[1], point[0]),
              // animation: google.maps.Animation.DROP,
              icon: "http://www.inspector.ltd/green-circle.png",
              map: that.map,
            })
          );
        });
        this.marker3 = mks;
      }
      // console.log(this.markers);
    },
  },
};
</script>